import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/copy.svg',
})
export class VliCopyComponent {}
